import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App/App';
import { Provider } from 'react-redux';
import Store, { history } from './config/redux-store';
import { unregister } from './registerServiceWorker';
import { ConnectedRouter } from 'react-router-redux';

import 'font-awesome/css/font-awesome.min.css';


ReactDOM.render(
<Provider store={ Store }>
  <ConnectedRouter history={ history }>
    <App history={ history } /> 
  </ConnectedRouter>
</Provider>,
document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js